// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { xmark16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-xmark': IconXmark;
    }
}

/**
 * The icon component for the 'xmark' icon
 */
export class IconXmark extends Icon {
    public constructor() {
        super(xmark16X16);
    }
}

registerIcon('icon-xmark', IconXmark);
export const iconXmarkTag = 'nimble-icon-xmark';
